import wrap from "svelte-spa-router/wrap";
import AuthView from "./AuthView.svelte";
export var AuthViewUtil;
(function (AuthViewUtil) {
    /**
     * 画面を認証必要にして返す
     * @param component
     * @param isAdminOnly
     */
    function createAuthWrap(component, isAdminOnly) {
        const wrapData = wrap({
            component: AuthView,
            props: {
                component: component,
                isAdminOnly: isAdminOnly,
            }
        });
        return wrapData;
    }
    AuthViewUtil.createAuthWrap = createAuthWrap;
    /**
     * 渡された authRoutes を AuthWrap して返す
     * @param authRoutes
     * @param isAdminOnly
     */
    function createAuthWrapRoutes(authRoutes, isAdminOnly = false) {
        const routes = {};
        for (let path in authRoutes) {
            const page = authRoutes[path];
            routes[path] = AuthViewUtil.createAuthWrap(page, isAdminOnly);
        }
        return routes;
    }
    AuthViewUtil.createAuthWrapRoutes = createAuthWrapRoutes;
})(AuthViewUtil || (AuthViewUtil = {}));
